import PaperContainer from "../PaperContainer";
import styled from "styled-components";

const DefaultModalContainer = styled(PaperContainer)`
  box-shadow: none;
  padding: 32px;
`;

export default DefaultModalContainer;
